import { render, staticRenderFns } from "./GathererLink.vue?vue&type=template&id=b6a8bcfe&"
import script from "./GathererLink.vue?vue&type=script&lang=ts&"
export * from "./GathererLink.vue?vue&type=script&lang=ts&"
import style0 from "./GathererLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GathererLink.vue"
export default component.exports